<template>
  <div>
    <div class="content-tab border-top-line mb-5">
      <v-container
        fluid
        style="width: 100%"
      >
        <v-row v-if="loaderSkeleton">
          <v-col cols="12">
            <div>
              <v-sheet
                height="450px"
                color="grey lighten-4"
                class="pa-0"
              >
                <v-skeleton-loader
                  class="mx-auto"
                  type="table"
                ></v-skeleton-loader>
              </v-sheet>
            </div>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col
            class="pa-0"
            cols="12"
            sm="12"
          >
            <div
              v-if="arrOrders.length > 0"
              class="width-100"
            >
              <div class="card-content">
                <v-simple-table
                  height="450px"
                  fixed-header
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th
                          v-for="(item, index) in texts.order.tableInDispute.headers"
                          :key="index"
                          :class="`${item.align} text-header-title mon-bold`"
                        >
                          {{ item.text }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in arrOrders"
                        :key="index"
                      >
                        <td class="text-left mon-regular">{{ item.sFolioId }}</td>
                        <td class="text-left mon-regular">{{ item.tAproxShippingDateView }}</td>
                        <td class="text-left mon-regular">{{ item.sEnterpriseName }}</td>
                        <td class="text-left mon-regular">${{ formatMoney(item.dTotalPrice) }} USD</td>
                        <td class="text-left mon-regular">{{ item.sPaid }}</td>
                        <td class="text-left mon-regular">{{ item.sCurrentStatusName }}</td>
                        <td class="text-right">
                          <v-btn
                            icon
                            @click="orderDetail(item.sSalesOrderId)"
                          >
                            <v-icon
                              color="#000"
                              size="16px"
                            >
                              mdi-eye
                            </v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <div class="display-flex align-items-center justify-content-center mt-4 mb-4">
                  <div class="pagination-styles">
                    <v-pagination
                      v-model="iCurrentPage"
                      :length="lengthPage"
                      color="#FFC556"
                      next-icon="mdi-menu-right"
                      prev-icon="mdi-menu-left"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="empty-table display-flex align-items-center justify-content-center"
              v-else
            >
              <p class="mon-regular">{{ texts.order.emptyText }}</p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderTabContentThreeLayout",
  props: {
    texts: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      //VARIABLES
      iCurrentPage: 1,
      lengthPage: 0,
      arrOrders: [],
      loaderSkeleton: true,
    };
  },
  beforeMount() {
    this.getOrders();
  },
  methods: {
    formatDate: function (date) {
      var new_date = MOMENT(date, "DD/MM/YYYY");
      var format_date = MOMENT(new_date).format("MMM. DD, YYYY.");
      return format_date;
    },
    formatMoney: function (money) {
      return FORMAT_MONEY(money);
    },
    orderDetail: function (id) {
      this.$router.push({
        path: `/order-detail/in-dispute/${id}`,
      });
    },
    getOrders: function () {
      this.loaderSkeleton = true;

      DB.get(`${URI}/api/v1/${this.selectLanguage}/sales-orders`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
        params: {
          iPageNumber: this.iCurrentPage,
          iItemsPerPage: 10,
          sSearch: this.sSearch,
          iFilter: 3,
          tStart: this.startDate,
          tEnd: this.endDate,
          bPaid: this.paymentStatus,
        },
      })
        .then((response) => {
          this.loaderSkeleton = false;

          this.arrOrders = response.data.results;
          this.lengthPage = response.data.iNumPages;
          this.iCurrentPage = response.data.iCurrentPage;
          this.$store.commit("refresher", false);
        })
        .catch((error) => {
          this.loaderSkeleton = false;

          this.mixError(error.response.data.message, error.response.status);
        });
    },
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    sSearch: function () {
      return this.$store.state.sSearch;
    },
    startDate() {
      return this.$store.state.startDate;
    },
    endDate() {
      return this.$store.state.endDate;
    },
    refesh: function () {
      return this.$store.state.refesh;
    },
    paymentStatus: function () {
      return this.$store.state.paymentStatus;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.getOrders();
      }
    },
    sSearch: lodash.debounce(function (val) {
      this.iCurrentPage = 1;
      this.getOrders();
    }, 500),
    endDate: function () {
      if (this.endDate) {
        this.iCurrentPage = 1;
        this.getOrders();
      }
    },
    startDate: function () {
      this.iCurrentPage = 1;
      this.getOrders();
    },
    paymentStatus: function () {
      this.iCurrentPage = 1;
      this.getOrders();
    },
    iCurrentPage: function () {
      this.getOrders();
    },
    refesh: function () {
      this.getOrders();
    },
  },
};
</script>

<style scoped>
.empty-table {
  background-color: #ffffff;
  border-radius: 10px;
  height: 450px;
}

.empty-table p {
  letter-spacing: 0px;
  color: #6e7d94;
  opacity: 1;
  font-size: 20px;
  margin-bottom: 0;
}

.cursor-pointer {
  cursor: pointer;
}

.text-link {
  color: #0971fb;
  text-decoration: underline;
}

.text-link:hover {
  cursor: pointer;
}

.text-header-title {
  color: #000000 !important;
  font-size: 14px !important;
  border-bottom: 1px solid #949494 !important;
}

.card-content {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  opacity: 1;
  padding: 10px;
}

.display-flex {
  display: flex;
}

.align-items {
  align-items: center;
}

.justify-content-center {
  justify-content: center;
}

.content-tab {
  padding: 20px 0px;
}

.border-top-line {
  border-top: 1px solid #cecece;
}

.border-bottom-line {
  border-bottom: 1px solid #cecece;
}
</style>